import React from 'react'

const CloseIcon = (props) => {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M1.26668 9.20535L0.794678 8.73335L4.52801 5.00001L0.794678 1.26668L1.26668 0.794678L5.00001 4.52801L8.73335 0.794678L9.20535 1.26668L5.47201 5.00001L9.20535 8.73335L8.73335 9.20535L5.00001 5.47201L1.26668 9.20535Z' fill='#33354D' />
    </svg>
  )
}

export default CloseIcon
